import { cardIssuersConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addCardIssuer = (state = initialState, action) => {
  switch (action.type) {
    case cardIssuersConstants.ADD_CARDISSUER_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case cardIssuersConstants.ADD_CARDISSUER_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case cardIssuersConstants.ADD_CARDISSUER_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case cardIssuersConstants.ADD_CARDISSUER_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
